import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import "./ReportPanel.css";

const ReportPanel = ({ reportUrl, onClose }) => {
    const [reportContent, setReportContent] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchReport = async () => {
            try {
                setIsLoading(true);
                const response = await fetch(reportUrl);
                if (!response.ok) {
                    throw new Error("Failed to load report");
                }
                const text = await response.text();
                setReportContent(text);
            } catch (err) {
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };

        if (reportUrl) {
            fetchReport();
        }
    }, [reportUrl]);

    if (isLoading) {
        return (
            <div className="report-panel">
                <div className="report-panel-header">
                    <h3><i className="fa fa-file-medical-alt"></i> AI Generated Report</h3>
                    <button className="report-close-btn" onClick={onClose}>
                        <i className="fa fa-times"></i>
                    </button>
                </div>
                <div className="report-panel-content loading">
                    <i className="fa fa-spinner fa-spin"></i>
                    <span>Loading report...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="report-panel">
                <div className="report-panel-header">
                    <h3><i className="fa fa-file-medical-alt"></i> AI Generated Report</h3>
                    <button className="report-close-btn" onClick={onClose}>
                        <i className="fa fa-times"></i>
                    </button>
                </div>
                <div className="report-panel-content error">
                    <i className="fa fa-exclamation-triangle"></i>
                    <span>{error}</span>
                </div>
            </div>
        );
    }

    return (
        <div className="report-panel">
            <div className="report-panel-header">
                <h3><i className="fa fa-file-medical-alt"></i> AI Generated Report</h3>
                <button className="report-close-btn" onClick={onClose}>
                    <i className="fa fa-times"></i>
                </button>
            </div>
            <div className="report-panel-content">
                <div className="markdown-content">
                    <ReactMarkdown>{reportContent}</ReactMarkdown>
                </div>
            </div>
            <div className="report-panel-footer">
                <span className="report-disclaimer">
                    <i className="fa fa-info-circle"></i>
                    This report was generated by AI and should be reviewed by a qualified medical professional.
                </span>
            </div>
        </div>
    );
};

export default ReportPanel;
